import { useQuery } from '@apollo/client';
import { Stack } from '@mui/material';
import { isEmpty, omit } from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import clientGraphql from '../../common/apollo-graphql';
import AuthContext from '../auth/context/AuthContext';
import ClinicDetails from '../clinics/Management/ClinicDetails/ClinicDetails';
import ClinicProviderListTable from '../clinics/Management/ClinicDetails/ClinicProviderListTable';
import { GET_CLINIC_DETAILS } from './gql/Query';
import { ROLE_ADMIN, ROLE_MED_DIRECTOR } from '../auth/constants/Role';
// import PropTypes from 'prop-types';

export default function ViewClinic({history}) {
  const currentUser = useContext(AuthContext);
  const [providerData, setProviderData] = useState({ rows: [], count: 0 });
  const [formattedData, setFormattedData] = useState({});
  const { loading, data } = useQuery(GET_CLINIC_DETAILS, {
    client: clientGraphql,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: { uuid: !isEmpty(currentUser) ? currentUser.uuid : null },
  });
  const isMedDirector = currentUser.role.toLowerCase() === ROLE_MED_DIRECTOR['value'];
  const isAdmin = currentUser.role.toLowerCase() === ROLE_ADMIN['value'];

  useEffect(() => {
    if (data) {
      const { clinic } = data;
      const newData = omit(clinic, [
        '__typename',
        'aggr_users',
        'address_json',
        'full_address',
        'documents',
        'specializations',
        'users',
        'required_documents',
        'optional_documents',
        'providers',
      ]);
      setFormattedData({
        ...newData,
      });
      setProviderData({
        rows: data.clinic.providers.map(item => {
          return {
            ...item,
          };
        }),
        count: data.clinic.providers.count,
      });
    }

    return () => {
      setFormattedData({});
    };
  }, [data]);

  const onEditClinic = useCallback(() => {
    history.push(`/manage/clinics/${formattedData.id}?edit=1`);
  }, [history, formattedData]);

  const handleOnEditClinic = isMedDirector || isAdmin ? onEditClinic : null;

  return (
    <Stack direction="column" spacing={1}>
      <ClinicDetails data={omit(formattedData, ['id'])} onEditClinic={handleOnEditClinic}/>
      <ClinicProviderListTable data={providerData} loading={loading} />
    </Stack>
  );
}
